module.exports = __webpack_public_path__ + "img/iot6.6709eee5.png";